import { TFunction } from "react-i18next";

export interface FiltersData {
  id: string;
  name: string;
  data: Data[];
}

export interface Data {
  id: number;
  name: string;
}

export interface Filter {
  name: string;
  values: FilterValue[];
}

export interface FilterValue {
  name: string;
  value: string;
  i18n: boolean;
}

export interface ApplyFilters {
  name: string;
  values: string[];
}

export function getHvFilterGroups(
  filterDb: Filter[],
  t: TFunction<string[]>,
  baseTranslationString: string
): FiltersData[] {
  const filtersData: FiltersData[] = filterDb
    ? filterDb.map((f) => {
        const arrData: Data[] = f.values
          ? f.values.map((v, i) => {
              if (v.i18n) {
                return {
                  id: i,
                  name: t(`${baseTranslationString}.${v.name}`),
                };
              }
              return {
                id: i,
                name: v.name,
              };
            })
          : [];
        return {
          id: f.name,
          name: t(`${baseTranslationString}.${f.name}`),
          data: arrData,
        };
      })
    : [];
  return filtersData;
}

export function getApiApplyFiltersFromHvFilterGroupsSeletedItems(
  filterDb: Filter[],
  selectedItems: number[][]
): ApplyFilters[] {
  let filters: ApplyFilters[] = [];
  if (filterDb) {
    filters = filterDb.map((f, i) => {
      const selectedValue = selectedItems[i] || [];
      const arrFilters: string[] = selectedValue.map((sValue) => {
        return f.values[sValue]?.value;
      });
      /* [];
        for (let index = 0; index < selectedValue.length; index += 1) {
          arrFilters.push(f.values[selectedValue[index]].value);
        } */

      return { name: f.name, values: arrFilters };
    });
  }
  return filters.filter((value) => (value.values?.length ?? 0) > 0);
}
